import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import WifiTetheringIcon from "@mui/icons-material/WifiTethering";
import WifiTetheringOffIcon from "@mui/icons-material/WifiTetheringOff";
import SuccessMessage from "./../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import Switch from "./../../components/Switch"
import useApiUrls from "../../useApiUrls";
import Pagination from "../components/Pagination";

const MerchantList = () => {
  // const [data, setData] = useState([]);
  const [dataLimit, setDataLimit] = useState(100);
  const [count, setCount] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [totalItems, setTotalItems] = useState(0);

  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [activeStatus, setActiveStatus] = useState("");
  const [isOn, setIsOn] = useState(false);
  const [message, setMessage] = useState("");
  const [results, setResults] = useState([]);
  const navigate = useNavigate();
  const { getUrlByOperation, error: urlError } = useApiUrls();
  const [formData, setFormData] = useState({
    id: "",
    merchantId: "",
    apikey: "",
    posname: "",
    to: "",
    from: "",
  });

  // State for Serial No Modal
  const [showSerialModal, setShowSerialModal] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [loadingDeviceInfo, setLoadingDeviceInfo] = useState(false);

  // State for file upload
  const fileInputRef = useRef(null);
  const [uploadMessage, setUploadMessage] = useState("");
  const [uploadStatus, setUploadStatus] = useState(""); // "success", "error", "warning"
  const [isUploading, setIsUploading] = useState(false);

  // State for Row JSON Modal
  const [showJsonModal, setShowJsonModal] = useState(false);
  const [jsonInput, setJsonInput] = useState('');
  const [currentRowItem, setCurrentRowItem] = useState(null);
  const [isSendingJson, setIsSendingJson] = useState(false);
  const [rowActionName, setRowActionName] = useState("Clean");

  // State for Row JSON Package Modal
  const [showJsonPackageModal, setShowJsonPackageModal] = useState(false);
  const [jsonPackageActions, setJsonPackageActions] = useState([]);
  const [selectedAction, setSelectedAction] = useState("");
  const [loadingActions, setLoadingActions] = useState(false);
  const [packageJsonInput, setPackageJsonInput] = useState('');
  const [isSendingPackage, setIsSendingPackage] = useState(false);

  const [data, setData] = useState(() => {
    const storedData = localStorage.getItem("data");
    return storedData ? JSON.parse(storedData) : [];
  });

  const handleSearch = () => {
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      navigate("/login");
      return;
    }

    const requestBody = {
      id: formData.id,
      applycreateddate: formData.ApplyDate,
      fromcreateddate: Math.floor(new Date(formData.FromDate).getTime() / 1000),
      endcreateddate: Math.floor(new Date(formData.EndDate).getTime() / 1000),
      active: formData.Active,
      posname: formData.posname || "",
      merchantid: formData.merchantId || "",
      key: formData.apikey || "",
      serialno: formData.serialno || "",
      ispageload: false,
      pagesize: dataLimit,
      currentpageno: count,
      withoutpagination: false,
      pagedirection: "",
    };

    const PosSearch = getUrlByOperation("posSearch");

    axios
      .post(PosSearch, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          const rows = response.data.data;
          setData(rows); // Ensure data is an array
          setHasMore(rows.length === Number(dataLimit));
          const approximateTotal = (count * Number(dataLimit)) + rows.length + (rows.length === Number(dataLimit) ? Number(dataLimit) : 0);
          setTotalItems(approximateTotal);
        } else {
          setData([]); // Default to empty array if data is undefined
          setHasMore(false);
          setTotalItems(0);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setHasMore(false);
        setTotalItems(0);
      });
  };

  useEffect(() => {
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      navigate("/login");
      return;
    }

    const requestBody = {
      id: 0,
      applycreateddate: false,
      fromcreateddate: 0,
      endcreateddate: 0,
      active: "",
      posname: "",
      merchantid: "",
      key: "",
      serialno: "",
      ispageload: false,
      pagesize: dataLimit,
      currentpageno: count,
      withoutpagination: false,
      pagedirection: "",
    };
    const PosSearch = getUrlByOperation("posSearch");

    axios
      .post(PosSearch, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          const rows = response.data.data;
          setData(rows);
          setHasMore(rows.length === Number(dataLimit));
          const approximateTotal = (count * Number(dataLimit)) + rows.length + (rows.length === Number(dataLimit) ? Number(dataLimit) : 0);
          setTotalItems(approximateTotal);
        } else {
          setData([]); // Default to empty array if data is undefined
          setHasMore(false);
          setTotalItems(0);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setHasMore(false);
        setTotalItems(0);
      });
  }, [getUrlByOperation, dataLimit, count, formData]);

  const handlePageChange = (page) => {
    setCount(page - 1);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setDataLimit(newItemsPerPage);
    setCount(0);
  };

  const totalPages = hasMore ? count + 2 : count + 1;

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleReset = () => {
    setFormData({
      ApplyDate: false,
      FromDate: "",
      EndDate: "",
      id: "",
      merchantId: "",
      Active: "Any",
      remark: "",
      apikey: "",
      posname: "",
      serialno: "",
    });
  };

  const handleAddPop = () => {
    navigate("/addmerchant");
  };

  const handleUpdatePop = (id) => {
    navigate(`/updatemerchant/${id}`);
  };
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this merchant?")) {
      // const localStorageData = JSON.parse(localStorage.getItem("user"));
      // const token = localStorageData?.token;
      // const userid = localStorageData?.userid;
      const token = getCookie("token");
      const userid = getCookie("userid");

      if (!token || !userid) {
        navigate("/login");
        return;
      }

      const requestBody = { id: id };

      const PosDelete = getUrlByOperation("posDelete");

      axios
        .post(PosDelete, requestBody, {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        })
        .then((response) => {
          // Refetch the data by calling the search API after delete to refresh the list
          setMessage("Data delete successfully!");
          handleSearch(); // Call the search API here to refresh the data after delete
        })
        .catch((error) => {
          console.error("Error deleting item:", error);
          setMessage("Failed to delete data");
        });
    }
  };

  const handleSendRowJson = (item) => {
    setCurrentRowItem(item);
    setShowJsonModal(true);
    setJsonInput("");
    setRowActionName("Clean");
  };

  const submitSendRowJson = async () => {
    if (!currentRowItem) return;

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      navigate("/login");
      return;
    }

    setIsSendingJson(true);
    const SendToDeviceGeneralAll = getUrlByOperation("SendToDeviceGeneralAll");
    const apiUrl = SendToDeviceGeneralAll;

    const requestBody = {
      merchantname: currentRowItem.merchantid || "",
      posid: parseInt(currentRowItem.id) || 0,
      actionname: rowActionName || "Clean",
      withaction: false,
      msg: jsonInput
    };

    try {
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          "accept": "text/plain",
          "UserId": userid,
          "X-Authorization": token,
          "Content-Type": "application/json-patch+json",
        },
      });

      if (response.data && response.data.isresponse) {
        if (Array.isArray(response.data.sendresult) && response.data.sendresult.length > 0) {
          const failures = response.data.sendresult.filter(
            (r) => r.responsestatus === "FAIL" || r.isresponse === false
          );
          if (failures.length > 0) {
            const errorMsgs = failures.map(
              (r) => `${r.posname || "Device"}: ${r.errormsg || "failed"}`
            );
            setMessage(`Failed: ${errorMsgs.join(", ")}`);
            setShowJsonModal(false);
            return;
          }
        }
        setMessage("JSON sent successfully!");
        setShowJsonModal(false);
      } else {
        setMessage(response.data?.errormsg || "Failed to send JSON");
      }
    } catch (error) {
      console.error("Error sending JSON:", error);
      setMessage("Error sending JSON");
    } finally {
      setIsSendingJson(false);
    }
  };

  const closeJsonModal = () => {
    setShowJsonModal(false);
    setCurrentRowItem(null);
  };

  const handleSendJsonPackage = (item) => {
    setCurrentRowItem(item);
    setShowJsonPackageModal(true);
    setPackageJsonInput('');
    setSelectedAction("");
    fetchJsonPackageActions();
  };

  const fetchJsonPackageActions = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      navigate("/login");
      return;
    }

    setLoadingActions(true);
    try {
      const response = await axios.get(
        "https://api.dqr-display-tms.bonrix.in/api/ActionOperation/GetDistinct/name",
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "accept": "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setJsonPackageActions(response.data.data);
      } else {
        setJsonPackageActions([]);
      }
    } catch (error) {
      console.error("Error fetching actions:", error);
      setJsonPackageActions([]);
    } finally {
      setLoadingActions(false);
    }
  };

  const handleActionChange = async (actionName) => {
    setSelectedAction(actionName);
    if (!actionName) {
      setPackageJsonInput("");
      return;
    }

    const selectedObj = jsonPackageActions.find(act => act.value === actionName);
    if (!selectedObj) return;

    setPackageJsonInput("Loading configuration JSON...");

    const token = getCookie("token");
    const userid = getCookie("userid");

    const getUrl = getUrlByOperation("ActionOperationGet");
    if (!getUrl) {
      setPackageJsonInput("");
      return;
    }

    try {
      const response = await axios.post(
        getUrl,
        {
          id: selectedObj.id,
          name: selectedObj.value
        },
        {
          headers: {
            "accept": "text/plain",
            "UserId": userid,
            "X-Authorization": token,
            "Content-Type": "application/json-patch+json"
          }
        }
      );

      if (response.data && response.data.isresponse && Array.isArray(response.data.data) && response.data.data.length > 0) {
        setPackageJsonInput(response.data.data[0].json || "");
      } else {
        setPackageJsonInput("");
      }
    } catch (error) {
      console.error("Error fetching action JSON:", error);
      setPackageJsonInput("");
    }
  };

  const closeJsonPackageModal = () => {
    setShowJsonPackageModal(false);
    setCurrentRowItem(null);
    setSelectedAction("");
    setPackageJsonInput('');
  };

  const submitSendJsonPackage = async () => {
    if (!currentRowItem || !selectedAction) return;

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      navigate("/login");
      return;
    }

    setIsSendingPackage(true);
    const SendToDeviceGeneralAll = getUrlByOperation("SendToDeviceGeneralAll");
    const apiUrl = SendToDeviceGeneralAll || "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/GeneralAll";

    const requestBody = {
      merchantname: currentRowItem.merchantid || "",
      posid: parseInt(currentRowItem.id) || 0,
      actionname: selectedAction,
      withaction: true,
      msg: packageJsonInput
    };

    try {
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          "accept": "text/plain",
          "UserId": userid,
          "X-Authorization": token,
          "Content-Type": "application/json-patch+json",
        },
      });

      if (response.data && response.data.isresponse) {
        if (Array.isArray(response.data.sendresult) && response.data.sendresult.length > 0) {
          const failures = response.data.sendresult.filter(
            (r) => r.responsestatus === "FAIL" || r.isresponse === false
          );
          if (failures.length > 0) {
            const errorMsgs = failures.map(
              (r) => `${r.posname || "Device"}: ${r.errormsg || "failed"}`
            );
            setMessage(`Failed: ${errorMsgs.join(", ")}`);
            closeJsonPackageModal();
            return;
          }
        }
        setMessage("JSON Package sent successfully!");
        closeJsonPackageModal();
      } else {
        setMessage(response.data?.errormsg || "Failed to send JSON Package");
      }
    } catch (error) {
      console.error("Error sending JSON Package:", error);
      setMessage("Error sending JSON Package");
    } finally {
      setIsSendingPackage(false);
    }
  };

  const handleToggle = async (e, item) => {
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      navigate("/login");
      return;
    }

    const PosActive = getUrlByOperation("posActive");
    const PosDeactive = getUrlByOperation("posDeactive");

    const apiUrl = item.active
      ? PosDeactive
      : PosActive;

    const requestBody = { id: item.id };

    try {
      await axios.post(apiUrl, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      // Update the state to reflect the change
      setData(
        data.map((d) => (d.id === item.id ? { ...d, active: !item.active } : d))
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const enhancedResults = results.map((res, index) => ({
    ...res,
    id: data[index]?.id, // Ensure IDs are correctly mapped
  }));

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000); // Clear the message after 3 seconds
      return () => clearTimeout(timer); // Cleanup the timer
    }
  }, [message]);

  const fetchData = async () => {
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userId = localStorageData?.userid;

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    try {
      console.log("Starting fetch operations");

      // Ensure IDs are valid and not empty
      const validIds = data.map((item) => item.id).filter((id) => id);

      const results = await Promise.all(
        validIds.map(async (id) => {
          console.log(`Fetching data for id: ${id}`);
          const PosConnectedStatus = getUrlByOperation("posConnectedStatus");
          const response = await fetch(
            `${PosConnectedStatus}/${id}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                "X-Authorization": token,
                UserId: userid,
              },
            }
          );

          if (!response.ok) {
            const errorData = await response.json();
            if (errorData.message === "relogin token expire") {
              throw new Error("Token expired");
            }
            throw new Error(
              `Error fetching data for id ${id}: ${response.statusText}`
            );
          }

          return response.json();
        })
      );

      setResults(results); // Update the state with results
      console.log("Results:", results);
    } catch (error) {
      console.error("Error fetching data:", error.message);

      if (error.message === "relogin token expire") {
        navigate("/login"); // Redirect to login page
      }
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData();
    }, 10000);

    return () => clearTimeout(timer); // Cleanup the timer on unmount
  }, [data, navigate, results]);

  const handleRefres = () => {
    fetchData();
  }

  const handleSerialClick = async (serialno) => {
    if (!serialno) return;

    setShowSerialModal(true);
    setLoadingDeviceInfo(true);
    setDeviceInfo(null);

    const token = getCookie("token");
    const userid = getCookie("userid");

    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/DeviceInfoOperation/Search',
        {
          serialno: serialno,
          pagesize: 1000,
          currentpageno: 0,
          withoutpagination: true,
          pagedirection: "string"
        },
        {
          headers: {
            'accept': 'text/plain',
            'UserId': userid,
            'X-Authorization': token,
            'Content-Type': 'application/json-patch+json'
          }
        }
      );

      if (response.data && response.data.isresponse && response.data.data) {
        setDeviceInfo(response.data.data);
      } else {
        setDeviceInfo([]);
        console.error("Invalid response format or error from API");
      }
    } catch (error) {
      console.error("Error fetching device info:", error);
      setDeviceInfo([]);
    } finally {
      setLoadingDeviceInfo(false);
    }
  };

  const closeSerialModal = () => {
    setShowSerialModal(false);
    setDeviceInfo(null);
  };

  // Handle upload button click
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  // Handle sample Excel download
  const handleDownloadSample = () => {
    // Create a link element and trigger download
    const link = document.createElement("a");
    link.href = "/marchantList.xlsx";
    link.download = "marchantList.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Handle file selection and upload
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      navigate("/login");
      return;
    }

    setIsUploading(true);
    setUploadMessage("");
    setUploadStatus("");

    // Create FormData
    const formData = new FormData();
    formData.append("file", file);

    try {
      const uploadUrl = getUrlByOperation("posUpload");
      const apiUrl = uploadUrl || "https://api.dqr-display-tms.bonrix.in/api/POSOperation/Upload";

      const response = await axios.post(apiUrl, formData, {
        headers: {
          "accept": "text/plain",
          "UserId": userid,
          "X-Authorization": token,
          "Content-Type": "multipart/form-data",
        },
      });

      // Parse response
      const responseData = response.data;

      if (responseData && responseData.isresponse) {
        const { totalrow, totalsuccessrow, totalfailrow, uploadinfo } = responseData;

        // Build message based on results
        let messageText = "";

        if (totalfailrow === 0 && totalsuccessrow > 0) {
          // All successful
          messageText = `Upload successful! ${totalsuccessrow} out of ${totalrow} rows processed successfully.`;
          setUploadStatus("success");
        } else if (totalsuccessrow > 0 && totalfailrow > 0) {
          // Partial success
          messageText = `Partial success: ${totalsuccessrow} succeeded, ${totalfailrow} failed out of ${totalrow} total rows.`;
          setUploadStatus("warning");

          // Add details about failed rows
          if (uploadinfo && Array.isArray(uploadinfo)) {
            const failedRows = uploadinfo.filter(item => !item.isresponse);
            if (failedRows.length > 0) {
              const errorDetails = failedRows
                .slice(0, 3) // Show first 3 errors
                .map(item => `Row ${item.rowindex}: ${item.errormsg || "Unknown error"}`)
                .join("; ");
              messageText += ` Errors: ${errorDetails}`;
              if (failedRows.length > 3) {
                messageText += ` and ${failedRows.length - 3} more...`;
              }
            }
          }
        } else if (totalfailrow > 0) {
          // All failed
          messageText = `Upload failed: All ${totalfailrow} rows failed.`;
          setUploadStatus("error");

          // Add details about failed rows
          if (uploadinfo && Array.isArray(uploadinfo)) {
            const failedRows = uploadinfo.filter(item => !item.isresponse);
            if (failedRows.length > 0) {
              const errorDetails = failedRows
                .slice(0, 3) // Show first 3 errors
                .map(item => `Row ${item.rowindex}: ${item.errormsg || "Unknown error"}`)
                .join("; ");
              messageText += ` Errors: ${errorDetails}`;
              if (failedRows.length > 3) {
                messageText += ` and ${failedRows.length - 3} more...`;
              }
            }
          }
        } else {
          // No rows processed
          messageText = responseData.errormsg || "Upload completed with no rows processed.";
          setUploadStatus("warning");
        }

        setUploadMessage(messageText);

        // Refresh data after successful upload
        if (totalsuccessrow > 0) {
          setTimeout(() => {
            handleSearch();
          }, 1000);
        }
      } else {
        // API returned error response
        setUploadStatus("error");
        setUploadMessage(responseData.errormsg || "Upload failed. Please try again.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      setUploadStatus("error");
      const errorMsg = error.response?.data?.errormsg ||
        error.response?.data?.message ||
        error.message ||
        "Failed to upload file. Please try again.";
      setUploadMessage(errorMsg);
    } finally {
      setIsUploading(false);
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  // Clear upload message after timeout
  useEffect(() => {
    if (uploadMessage) {
      const timer = setTimeout(() => {
        setUploadMessage("");
        setUploadStatus("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [uploadMessage]);

  return (
    <>
      <Menu />

      <div>
        <div className="wrapper">
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="d-flex justify-content-between align-items-end w-100">
                    <h1 className="mb-0">Merchant</h1>
                    <div className="ms-auto">
                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                        style={{ display: "none" }}
                      />
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        onClick={handleUploadClick}
                        disabled={isUploading}
                      >
                        {isUploading ? "Uploading..." : "Upload"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-info me-2"
                        onClick={handleDownloadSample}
                      >
                        Sample XL
                      </button>
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleAddPop}
                      >
                        Add Merchant
                      </button>
                    </div>
                  </div>
                </div>
                {/* <hr /> */}
              </div>
              {/* /.container-fluid */}
            </section>{" "}
            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
                <form className="mb-4" id="src-fo">
                  <div className="row">
                    <div className="col-md-10 offset-md-1">
                      <div className="row">
                        <div className="col-3">
                          <div className="form-group">
                            <label htmlFor="ApplyDate">Apply Date</label>
                            <input
                              type="checkbox"
                              className="form-control"
                              name="ApplyDate"
                              checked={formData.ApplyDate}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="form-group">
                            <label htmlFor="FromDate">From</label>
                            <input
                              type="date"
                              className="form-control"
                              name="FromDate"
                              value={formData.FromDate}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="form-group">
                            <label htmlFor="EndDate">End</label>
                            <input
                              type="date"
                              className="form-control"
                              name="EndDate"
                              value={formData.EndDate}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="form-group">
                            <label>Id:</label>
                            <input
                              type="number"
                              className="form-control"
                              name="id"
                              value={formData.id}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-3">
                          <div className="form-group">
                            <label>Merchant Id:</label>
                            <input
                              type="search"
                              className="form-control"
                              name="merchantId"
                              value={formData.merchantId}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="form-group">
                            <label>Active:</label>
                            <select
                              name="Active"
                              className="form-control"
                              value={formData.Active}
                              onChange={handleChange}
                            >
                              <option value="Any">Any</option>
                              <option value="true">Active</option>
                              <option value="false">Deactive</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-3">
                          <div className="form-group">
                            <label>Api Key:</label>

                            <input
                              type="search"
                              className="form-control"
                              name="apikey"
                              value={formData.apikey}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="form-group">
                            <label>Pos Name:</label>
                            <input
                              type="search"
                              className="form-control"
                              name="posname"
                              value={formData.posname}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="form-group">
                            <label>Serial No:</label>
                            <input
                              type="search"
                              className="form-control"
                              name="serialno"
                              value={formData.serialno}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-footer">
                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          id="src-it"
                          onClick={handleSearch}
                        >
                          Search
                        </button>
                        <button
                          type="button"
                          className="btn btn-warning "
                          id="rst-src"
                          onClick={handleReset}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <hr />
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div style={{ overflowX: 'auto' }}>
                        <table className="table table-hover text-nowrap">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Merchant Name</th>
                              <th>ApiKey</th>
                              <th>Pos Name</th>
                              <th>Create date</th>
                              <th>Remark</th>
                              <th>Serial No</th>
                              <th>Active</th>
                              <th>Action</th>
                              <th>
                                Connection status
                                <button style={{ marginLeft: "8px" }} onClick={handleRefres}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                                  </svg>
                                </button>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((item, index) => {
                              // Log the current item and enhanced results for debugging
                              console.log("Item:", item);
                              console.log("Enhanced Results:", enhancedResults);

                              // Find the result corresponding to the current item based on item.id
                              const connectionStatus = enhancedResults.find(
                                (res) => res.id === item.id
                              );

                              // Log the connection status for debugging
                              console.log("Connection Status:", connectionStatus);

                              return (
                                <tr key={index}>
                                  <td>{item.id}</td>
                                  <td>{item.merchantid}</td>
                                  <td>{item.apikey}</td>
                                  <td>{item.posname}</td>
                                  <td>{item.createddate}</td>
                                  <td>{item.remark}</td>
                                  <td>
                                    {item.serialno ? (
                                      <button
                                        className="btn btn-outline-info btn-sm"
                                        onClick={() => handleSerialClick(item.serialno)}
                                      >
                                        {item.serialno}
                                      </button>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    <Switch
                                      isOn={item.active}
                                      handleToggle={(e) => handleToggle(e, item)}
                                      id={item.id}
                                    />
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-success btn-sm mr-2"
                                      id={item.id}
                                      onClick={() => handleUpdatePop(item.id)}
                                      title="Update"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm mr-2"
                                      id={item.id}
                                      onClick={(e) => handleDelete(item.id)}
                                      title="Delete"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm me-2"
                                      onClick={() => handleSendJsonPackage(item)}
                                      title="Send JSON Package"
                                    >
                                      <i className="fas fa-box"></i>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-warning btn-sm me-2"
                                      onClick={() => handleSendRowJson(item)}
                                      title="send row json"
                                    >
                                      <i className="fas fa-paper-plane"></i>
                                    </button>
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {/* Check if connectionStatus exists and display the appropriate icon */}
                                    {connectionStatus?.connected === true ? (
                                      <WifiTetheringIcon
                                        fontSize="large"
                                        style={{ color: "green" }}
                                      />
                                    ) : (
                                      <WifiTetheringOffIcon
                                        fontSize="large"
                                        style={{ color: "red" }}
                                      />
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      <Pagination
                        currentPage={count + 1}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                        itemsPerPage={Number(dataLimit)}
                        onItemsPerPageChange={handleItemsPerPageChange}
                        totalItems={totalItems}
                        showPageNumbers={false}
                        showItemsPerPageSelector={true}
                      />

                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <aside className="control-sidebar control-sidebar-dark">
            {/* Control sidebar content goes here */}
          </aside>
        </div>

        {/* ./wrapper */}
      </div>
      {message && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 9999,
            minWidth: "300px"
          }}
        >
          {message.includes("successfully") ? (
            <SuccessMessage message={message} />
          ) : (
            <FailedMessage message={message} />
          )}
        </div>
      )}

      {/* Upload messages */}
      {uploadMessage && uploadStatus === "success" && (
        <SuccessMessage
          message={uploadMessage}
          onClose={() => {
            setUploadMessage("");
            setUploadStatus("");
          }}
        />
      )}
      {uploadMessage && uploadStatus === "error" && (
        <FailedMessage message={uploadMessage} />
      )}
      {uploadMessage && uploadStatus === "warning" && (
        <>
          <svg style={{ display: "none" }}>
            <symbol
              id="exclamation-triangle-fill"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            </symbol>
          </svg>
          <div
            style={{
              position: "fixed",
              top: "20px",
              right: "10px",
              width: "25%",
              zIndex: "9999",
            }}
          >
            <div
              className="alert alert-warning d-flex align-items-center"
              role="alert"
              style={{ marginBottom: "10px" }}
            >
              <svg
                className="bi flex-shrink-0 me-2"
                width="24"
                height="24"
                role="img"
                aria-label="Warning:"
              >
                <use href="#exclamation-triangle-fill" />
              </svg>
              &nbsp;
              <div>{uploadMessage}</div>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setUploadMessage("");
                  setUploadStatus("");
                }}
                aria-label="Close"
                style={{ marginLeft: "auto" }}
              ></button>
            </div>
          </div>
        </>
      )}
      {/* Serial No Modal */}
      {
        showSerialModal && (
          <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Device Information</h5>
                  <button type="button" className="close" onClick={closeSerialModal}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                  {loadingDeviceInfo ? (
                    <div className="text-center p-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : deviceInfo && deviceInfo.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Property</th>
                            <th>Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {deviceInfo.map((device, index) => (
                            <React.Fragment key={index}>
                              <tr><td><strong>Serial No</strong></td><td>{device.serialno}</td></tr>
                              <tr><td><strong>Device Type</strong></td><td>{device.devicetype}</td></tr>
                              <tr><td><strong>Model No</strong></td><td>{device.devicemodelno}</td></tr>
                              <tr><td><strong>Hardware</strong></td><td>{device.devicehardware}</td></tr>
                              <tr><td><strong>Software Version</strong></td><td>{device.devicesoftwareversion}</td></tr>
                              <tr><td><strong>Resolution</strong></td><td>{device.width} x {device.height}</td></tr>
                              <tr><td><strong>Active</strong></td><td>{device.deviceactive ? "Yes" : "No"}</td></tr>
                              <tr><td><strong>Created Date</strong></td><td>{device.createddate}</td></tr>
                              <tr><td><strong>Last Modified</strong></td><td>{device.lastmodifieddate}</td></tr>
                              <tr><td><strong>Orientation</strong></td><td>{device.orientation || "-"}</td></tr>
                              <tr><td><strong>Firmware</strong></td><td>{device.firmware || "-"}</td></tr>
                              <tr><td><strong>POS Name</strong></td><td>{device.posname || "-"}</td></tr>
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="alert alert-warning">No device information found.</div>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={closeSerialModal}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Row JSON Modal */}
      {
        showJsonModal && (
          <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Send JSON to Device</h5>
                  <button type="button" className="close" onClick={closeJsonModal}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="form-group mb-3">
                    <label>Action Name:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={rowActionName}
                      onChange={(e) => setRowActionName(e.target.value)}
                      placeholder="Enter action name"
                    />
                  </div>
                  <div className="form-group">
                    <label>JSON Message:</label>
                    <textarea
                      className="form-control"
                      rows="8"
                      value={jsonInput}
                      onChange={(e) => setJsonInput(e.target.value)}
                      style={{ fontFamily: "monospace" }}
                    ></textarea>
                    <small className="text-muted">Enter the valid JSON object to be sent in the 'msg' field.</small>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={closeJsonModal}>
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={submitSendRowJson}
                    disabled={isSendingJson}
                  >
                    {isSendingJson ? "Sending..." : "Send JSON"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Row JSON Package Modal */}
      {
        showJsonPackageModal && (
          <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Send JSON Package</h5>
                  <button type="button" className="close" onClick={closeJsonPackageModal}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="form-group">
                    <label>Select Action:</label>
                    {loadingActions ? (
                      <div className="text-center">
                        <div className="spinner-border spinner-border-sm" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <select
                        className="form-control"
                        value={selectedAction}
                        onChange={(e) => handleActionChange(e.target.value)}
                      >
                        <option value="">--Select Action--</option>
                        {jsonPackageActions.map((action, index) => (
                          <option key={index} value={action.value}>
                            {action.value}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  <div className="form-group mt-3">
                    <label>JSON Message:</label>
                    <textarea
                      className="form-control"
                      rows="8"
                      value={packageJsonInput}
                      onChange={(e) => setPackageJsonInput(e.target.value)}
                      style={{ fontFamily: "monospace" }}
                    ></textarea>
                    <small className="text-muted">Enter the valid JSON object to be sent in the 'msg' field.</small>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={closeJsonPackageModal}>
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!selectedAction || isSendingPackage}
                    onClick={submitSendJsonPackage}
                  >
                    {isSendingPackage ? "Sending..." : "Send"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
};

export default MerchantList;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}